import { createContext, useContext, useEffect, useRef, useState } from "react";
import { Button, Collapse, Label, UncontrolledTooltip } from "reactstrap";
import moment from "moment";
import jsPDF from "jspdf";

import "../../styles/DataValidation.css";
import "../../styles/StackPlots.css";
import { default as utilIcons } from "../../resources/utilIcons";
import { colors } from "../../styles/colors";

import ValidationPlot from "./ValidationPlot";
import { data as dummyData, config as dummyConfig } from "./StackPlotDummy";
import { RestContext } from "../../App";
import { DATA_URL, STACKPLOT_URL, VALIDATION_URL } from "../../serverConfig";
import { checkMobile, isNumeric } from "../../util/globals";
import SearchableSelect from "../../components/SearchableSelect";
import SortControls from "../../components/SortControls";
import { deTzTimestamp } from "../../util/timeUtils";

const DataValidationContext = createContext(null);

const AQMET_COLUMNS = {
    siteNo: "Site No",
    recordDate: "Record Date",
    parCode: "Par Code",
    validationCode: "Validation Code",
    controlVal: "Control Val",
    validatedVal: "Validated Val",
    rawVal: "Raw Val",
    sourceCode: "Source Code",
    loggerFlag: "Logger Flag",
    screenFlag: "Screen Flag",
    status: "Status",
    updateDate: "Update Date",
    updateBy: "Update By",
    insertDate: "Insert Date",
    qualifierCode: "Qualifier Code",
};

function DataValidation({ selectedSite }) {
    const [dateRange, setDateRange] = useState({});
    const [selectedPars, setSelectedPars] = useState([]);
    const [columns, setColumns] = useState([]);
    const [data, setData] = useState([]);
    const [stackplotData, setStackplotData] = useState({});
    const [loading, setLoading] = useState(false);
    const [loadingProgress, setLoadingProgress] = useState(1);
    const [chartRefs, setChartRefs] = useState();
    const [callbacks, setCallbacks] = useState({});
    const [changed, setChanged] = useState(false);

    const { sendGetRequest, sendPostRequest } = useContext(RestContext);

    const loadingOptions = useRef(loading);
    const stackPlotRef = useRef(null);

    // useEffect(() => {
    //     setStackplotData(explodeData(data));
    // }, [data, selectedOptions]);

    // useEffect(() => {
    //     setDateRange({ min: getMinDate(), max: getMaxDate() });
    // }, [stackplotData]);

    useEffect(() => {
        setDateRange({
            min: moment()
                .set("hour", 0)
                .set("minute", 0)
                .set("second", 0)
                .set("millisecond", 0)
                .set("date", 1)
                .subtract(1, "month")
                .format("YYYY-MM-DDTHH:mm"),
            max: moment()
                .set("hour", 0)
                .set("minute", 0)
                .set("second", 0)
                .set("millisecond", 0)
                .set("date", 1)
                .format("YYYY-MM-DDTHH:mm"),
        });
    }, []);

    useEffect(() => {
        console.log(data);
    }, [data]);

    useEffect(() => {
        setChanged(selectedPars.length > 0); // Can load data whenever date range is updated or selected parameter list is updated (and not empty)
    }, [dateRange, selectedPars]);

    const beginLoad = () => {
        const payload = {
            siteId: selectedSite,
            minDate: deTzTimestamp(dateRange.min),
            maxDate: deTzTimestamp(dateRange.max),
            parCodeList: selectedPars,
        };
        setLoading(true);
        sendPostRequest(
            VALIDATION_URL + "/getData",
            payload,
            (response) => {
                setData(response.data);
                setLoading(false);
                setChanged(false);
            },
            (error) => {
                setLoading(false);
            }
        );
    };

    // const beginLoad = (dataOptions) => {
    //     if (!selectedOptions || !config || !config.parCodes) return;
    //     if (!dataOptions) {
    //         dataOptions = {
    //             selectedSite: selectedOptions.selectedSite,
    //             precision: selectedOptions.precision,
    //             sameConfig: selectedOptions.sameConfig,
    //             loadedMin: selectedOptions.sameConfig ? getLoadedMin() : null,
    //             loadedMax: selectedOptions.sameConfig ? getLoadedMax() : null,
    //             minTimestamp: selectedOptions.datesToLoad.minTimestamp,
    //             maxTimestamp: selectedOptions.datesToLoad.maxTimestamp,
    //             dataType: config.dataType,
    //             parCodes: config.parCodes,
    //             calPars: config.calPars,
    //         };
    //     }
    //     if (!loading) {
    //         setLoading(dataOptions);
    //     }
    // };

    // const reloadData = () => {
    //     if (!selectedOptions || !config || !config.parCodes || !config.calPars)
    //         return;
    //     const dataOptions = {
    //         selectedSite: selectedOptions.selectedSite,
    //         precision: selectedOptions.precision,
    //         sameConfig: selectedOptions.sameConfig,
    //         loadedMin: null,
    //         loadedMax: null,
    //         minTimestamp: selectedOptions.datesToLoad.minTimestamp,
    //         maxTimestamp: selectedOptions.datesToLoad.maxTimestamp,
    //         dataType: config.dataType,
    //         parCodes: config.parCodes,
    //         calPars: config.calPars,
    //     };
    //     beginLoad(dataOptions);
    // };

    // const loadInfo = () => {
    //     if (!selectedOptions) return;
    //     loadingOptions.current = loading;
    //     if (loading) {
    //         if (
    //             loading.loadedMin &&
    //             loading.loadedMin < selectedOptions.datesToLoad.minTimestamp
    //         ) {
    //             setLoading(null);
    //             return;
    //         }
    //         if (["RAWCAL", "VALCAL"].includes(config.dataType)) {
    //             const payload = {
    //                 precision: loading.precision,
    //                 minTimestamp: loading.minTimestamp,
    //                 maxTimestamp: loading.maxTimestamp,
    //                 loadedMin: loading.loadedMin,
    //                 loadedMax: loading.loadedMax,
    //                 dataType: loading.dataType,
    //                 calPars: loading.calPars,
    //             };
    //             sendPostRequest(
    //                 `${DATA_URL}/stackplot/info/${loading.selectedSite}`,
    //                 payload,
    //                 (response) => {
    //                     const numPages = response.data.numPages;
    //                     const pageSize = response.data.pageSize;
    //                     setLoadingProgress(0);
    //                     if (numPages > 0) {
    //                         setColumns(response.data.columns);
    //                         if (loading.sameConfig) {
    //                             loadPage(1, numPages, pageSize, loading, data);
    //                         } else {
    //                             loadPage(1, numPages, pageSize, loading);
    //                         }
    //                     } else {
    //                         if (!loading.sameConfig) {
    //                             setColumns([]);
    //                             setData({});
    //                         }
    //                         setLoading(null);
    //                     }
    //                 },
    //                 (error) => {
    //                     setLoading(null);
    //                 }
    //             );
    //         } else {
    //             const payload = {
    //                 precision: loading.precision,
    //                 minTimestamp: loading.minTimestamp,
    //                 maxTimestamp: loading.maxTimestamp,
    //                 loadedMin: loading.loadedMin,
    //                 loadedMax: loading.loadedMax,
    //                 dataType: loading.dataType,
    //                 parCodes: loading.parCodes,
    //             };
    //             sendPostRequest(
    //                 `${DATA_URL}/stackplot/info/${loading.selectedSite}`,
    //                 payload,
    //                 (response) => {
    //                     const numPages = response.data.numPages;
    //                     const pageSize = response.data.pageSize;
    //                     setLoadingProgress(0);
    //                     if (numPages > 0) {
    //                         setColumns(response.data.columns);
    //                         if (loading.sameConfig) {
    //                             loadPage(1, numPages, pageSize, loading, data);
    //                         } else {
    //                             loadPage(1, numPages, pageSize, loading);
    //                         }
    //                     } else {
    //                         if (!loading.sameConfig) {
    //                             setColumns([]);
    //                             setData({});
    //                         }
    //                         setLoading(null);
    //                     }
    //                 },
    //                 (error) => {
    //                     setLoading(null);
    //                 }
    //             );
    //         }
    //     }
    // };

    // const loadPage = (
    //     pageNumber,
    //     numPages,
    //     pageSize,
    //     dataOptions,
    //     tempData = {}
    // ) => {
    //     if (
    //         JSON.stringify(loadingOptions.current) ===
    //         JSON.stringify(dataOptions)
    //     ) {
    //         if (["RAWCAL", "VALCAL"].includes(config.dataType)) {
    //             const payload = {
    //                 stackplotId: selectedConfig,
    //                 precision: dataOptions.precision,
    //                 page: pageNumber,
    //                 pageSize: pageSize,
    //                 numPages: numPages,
    //                 loadedMin: dataOptions.loadedMin,
    //                 loadedMax: dataOptions.loadedMax,
    //                 minTimestamp: dataOptions.minTimestamp,
    //                 maxTimestamp: dataOptions.maxTimestamp,
    //                 dataType: dataOptions.dataType,
    //                 calPars: dataOptions.calPars,
    //             };
    //             sendPostRequest(
    //                 `${DATA_URL}/stackplot/cal/${selectedSite}`,
    //                 payload,
    //                 (response) => {
    //                     if (
    //                         JSON.stringify(loadingOptions.current) ===
    //                         JSON.stringify(dataOptions)
    //                     ) {
    //                         const responseData = response.data;

    //                         tempData = { ...tempData, ...responseData.data };
    //                         setData(tempData);
    //                         setLoadingProgress(pageNumber / numPages);
    //                         if (pageNumber < numPages) {
    //                             loadPage(
    //                                 pageNumber + 1,
    //                                 numPages,
    //                                 pageSize,
    //                                 dataOptions,
    //                                 tempData
    //                             );
    //                         } else {
    //                             setLoading(null);
    //                             if (!selectedOptions.sameConfig) {
    //                                 setSelectedOptions((values) => ({
    //                                     ...values,
    //                                     sameConfig: true,
    //                                 }));
    //                             }
    //                         }
    //                     }
    //                 },
    //                 (error) => {
    //                     setLoading(null);
    //                 }
    //             );
    //         } else {
    //             const payload = {
    //                 stackplotId: selectedConfig,
    //                 precision: dataOptions.precision,
    //                 page: pageNumber,
    //                 pageSize: pageSize,
    //                 numPages: numPages,
    //                 loadedMin: dataOptions.loadedMin,
    //                 loadedMax: dataOptions.loadedMax,
    //                 minTimestamp: dataOptions.minTimestamp,
    //                 maxTimestamp: dataOptions.maxTimestamp,
    //                 dataType: dataOptions.dataType,
    //                 parCodes: dataOptions.parCodes,
    //             };
    //             sendPostRequest(
    //                 `${DATA_URL}/stackplot/${selectedSite}`,
    //                 payload,
    //                 (response) => {
    //                     if (
    //                         JSON.stringify(loadingOptions.current) ===
    //                         JSON.stringify(dataOptions)
    //                     ) {
    //                         const responseData = response.data;

    //                         tempData = { ...tempData, ...responseData.data };
    //                         setData(tempData);
    //                         setLoadingProgress(pageNumber / numPages);
    //                         if (pageNumber < numPages) {
    //                             loadPage(
    //                                 pageNumber + 1,
    //                                 numPages,
    //                                 pageSize,
    //                                 dataOptions,
    //                                 tempData
    //                             );
    //                         } else {
    //                             setLoading(null);
    //                             if (!selectedOptions.sameConfig) {
    //                                 setSelectedOptions((values) => ({
    //                                     ...values,
    //                                     sameConfig: true,
    //                                 }));
    //                             }
    //                         }
    //                     }
    //                 },
    //                 (error) => {
    //                     setLoading(null);
    //                 }
    //             );
    //         }
    //     }
    // };

    // const getLoadedMin = () => {
    //     if (!data) return null;
    //     const timestamps = Object.keys(data);
    //     if (!timestamps.length) return null;
    //     return getMin(timestamps);
    // };

    // const getLoadedMax = () => {
    //     if (!data) return null;
    //     const timestamps = Object.keys(data);
    //     if (!timestamps.length) return null;
    //     return getMax(timestamps);
    // };

    const getMinDate = () => {
        if (!stackplotData || !stackplotData._timestamps) return 0;
        return moment
            .unix(stackplotData._timestamps[0])
            .format("YYYY-MM-DDTHH:mm");
    };

    const getMaxDate = () => {
        if (!stackplotData || !stackplotData._timestamps) return 0;
        return moment
            .unix(
                stackplotData._timestamps[stackplotData._timestamps.length - 1]
            )
            .format("YYYY-MM-DDTHH:mm");
    };

    const getMin = (data) => {
        if (data.length === 0) return -Infinity;
        else if (data.length === 1) return data[0];
        else {
            let min = data[0];
            for (let i = 1; i < data.length; i++) {
                if (data[i] < min) min = data[i];
            }
            return min;
        }
    };

    const getMax = (data) => {
        if (data.length === 0) return Infinity;
        else if (data.length === 1) return data[0];
        else {
            let max = data[0];
            for (let i = 1; i < data.length; i++) {
                if (data[i] > max) max = data[i];
            }
            return max;
        }
    };

    // const explodeData = (rawData) => {
    //     if (!config?.dataType || !rawData || !columns) return null;
    //     const explodedData = {};
    //     if (["RAWCAL", "VALCAL"].includes(config.dataType)) {
    //         for (let i = 0; i < columns.length; i++) {
    //             if (!Array.isArray(columns[i])) return null;
    //             if (!columns[i][0].match(/_(FLAG|CODE)$/)) {
    //                 explodedData[columns[i]] = {
    //                     columnIndex: i,
    //                 };
    //             }
    //         }
    //     } else {
    //         for (let i = 0; i < columns.length; i++) {
    //             if (Array.isArray(columns[i])) return null;
    //             if (!columns[i].match(/_(FLAG|CODE)$/)) {
    //                 explodedData[columns[i]] = {
    //                     columnIndex: i,
    //                 };
    //             }
    //         }
    //     }

    //     let minTimestamp = selectedOptions.datesToLoad.minTimestamp;
    //     let maxTimestamp = selectedOptions.datesToLoad.maxTimestamp;
    //     let timestamps = [];
    //     let interval = ["1-min", "5-min", "15-min"].includes(
    //         config?.precision || ""
    //     )
    //         ? 60
    //         : 3600;
    //     for (let i = 0; i <= (maxTimestamp - minTimestamp) / interval; i++) {
    //         timestamps.push(minTimestamp + i * interval);
    //     }

    //     for (let timestamp of timestamps) {
    //         let row = rawData[timestamp];
    //         if (row) {
    //             for (let parCode in explodedData) {
    //                 explodedData[parCode][timestamp] = [
    //                     row[explodedData[parCode].columnIndex],
    //                     row[explodedData[parCode].columnIndex + 1],
    //                 ];
    //             }
    //         }
    //     }
    //     explodedData._timestamps = timestamps;
    //     return explodedData;
    // };

    const doXScroll = (scrollOptions) => {
        if (
            !dateRange ||
            dateRange.min === undefined ||
            dateRange.max === undefined ||
            !stackplotData ||
            !stackplotData._timestamps ||
            stackplotData._timestamps.length < 2
        )
            return;
        const { direction, quantity, unit } = scrollOptions;
        let offset = 0;
        switch (direction) {
            case "left":
                let dataMin = moment.unix(stackplotData._timestamps[0]);
                let currentMin = moment(dateRange.min, "YYYY-MM-DDTHH:mm");
                let targetMin = moment(currentMin).subtract(quantity, unit);
                if (targetMin.unix() < dataMin.unix()) {
                    offset = currentMin.unix() - dataMin.unix();
                } else {
                    offset = currentMin.unix() - targetMin.unix();
                }
                setDateRange({
                    min: currentMin
                        .subtract(offset, "seconds")
                        .format("YYYY-MM-DDTHH:mm"),
                    max: moment(dateRange.max, "YYYY-MM-DDTHH:mm")
                        .subtract(offset, "seconds")
                        .format("YYYY-MM-DDTHH:mm"),
                });
                return;
            case "right":
                let dataMax = moment.unix(
                    stackplotData._timestamps[
                        stackplotData._timestamps.length - 1
                    ]
                );
                let currentMax = moment(dateRange.max, "YYYY-MM-DDTHH:mm");
                let targetMax = moment(currentMax).add(quantity, unit);
                if (targetMax.unix() > dataMax.unix()) {
                    offset = dataMax.unix() - currentMax.unix();
                } else {
                    offset = targetMax.unix() - currentMax.unix();
                }
                setDateRange({
                    min: moment(dateRange.min, "YYYY-MM-DDTHH:mm")
                        .add(offset, "seconds")
                        .format("YYYY-MM-DDTHH:mm"),
                    max: currentMax
                        .add(offset, "seconds")
                        .format("YYYY-MM-DDTHH:mm"),
                });
                return;
            default:
                return;
        }
    };

    const updateTimeframe = (minTimestamp, maxTimestamp) => {
        setDateRange({
            min: minTimestamp,
            max: maxTimestamp,
        });
    };

    const handleMinDate = (event) => {
        const value = event.target.value;
        setDateRange((values) => ({ ...values, min: value }));
    };

    const handleMaxDate = (event) => {
        const value = event.target.value;
        setDateRange((values) => ({ ...values, max: value }));
    };

    const clearCursors = () => {
        for (let pair of chartRefs) {
            const chart = pair[1].current;
            if (chart.options.plugins.annotation) {
                chart.options.plugins.annotation.annotations = [];
                chart.update();
            }
        }
    };

    const registerCallback = (callbackName, callbackFn) => {
        setCallbacks((values) => ({ ...values, [callbackName]: callbackFn }));
    };

    return (
        <DataValidationContext.Provider
            value={{
                dateRange,
                updateTimeframe,
                setSelectedPars,
                handleMinDate,
                handleMaxDate,
                getMinDate,
                getMaxDate,
                doXScroll,
                loading,
                changed,
            }}
        >
            <div id="data-validation">
                <ValidationControls
                    selectedSite={selectedSite}
                    beginLoad={beginLoad}
                />
                <div id="stackplot-controls-help">
                    <div className="stackplot-controls-help-blurb">
                        <b>Drag:</b> Pan X Axis (all charts)
                    </div>
                    <div className="stackplot-controls-help-blurb">
                        <b>Ctrl+Scroll:</b> Zoom X Axis (all charts)
                    </div>
                    <div className="stackplot-controls-help-blurb">
                        <b>Shift+Drag</b> Pan Y Axis (single chart)
                    </div>
                    <div className="stackplot-controls-help-blurb">
                        <b>Shift+Scroll:</b> Zoom Y Axis (single chart)
                    </div>
                    <div className="stackplot-controls-help-blurb">
                        <b>Shift+Dbl Click:</b> Reset Y Axis (single chart)
                    </div>
                </div>
                {/* <ValidationPlot
                    data={stackplotData}
                    config={config}
                    dateRange={dateRange}
                    stackPlotRef={stackPlotRef}
                    printable={printMode}
                    bubbleChartRefs={setChartRefs}
                    callbacks={callbacks}
                /> */}
                <ValidationTable
                    data={data}
                    registerCallback={registerCallback}
                />
                <LoadingScreen
                    hidden={!loading}
                    loadingProgress={loadingProgress}
                    isMobile={checkMobile()}
                />
            </div>
        </DataValidationContext.Provider>
    );
}

function ValidationControls({ selectedSite, beginLoad }) {
    const {
        dateRange,
        updateTimeframe,
        handleMinDate,
        handleMaxDate,
        getMinDate,
        getMaxDate,
        selectedOptions,
        doXScroll,
        loading,
        changed,
    } = useContext(DataValidationContext);

    return (
        <div id="validation-controls">
            <div className="stackplot-control-wrapper">
                <Label>Timeframe:</Label>
                <StackPlotTimeFrameSelector updateTimeframe={updateTimeframe} />
            </div>
            <ParCodeSelector selectedSite={selectedSite} />
            <Button
                id="validation-load-button"
                onClick={beginLoad}
                disabled={!changed}
            >
                Load Data
            </Button>
            <div id="x-zoom-controls" className="stackplot-control-wrapper">
                <Label>View:</Label>
                <input
                    type="datetime-local"
                    onChange={handleMinDate}
                    min={getMinDate()}
                    max={dateRange.max || getMaxDate()}
                    step={
                        selectedOptions
                            ? selectedOptions.precision.match(/\d+-min/)
                                ? 60
                                : 3600
                            : 1
                    }
                    value={dateRange.min || ""}
                />
                <span>-</span>
                <input
                    type="datetime-local"
                    onChange={handleMaxDate}
                    min={dateRange.min || getMinDate()}
                    max={getMaxDate()}
                    step={
                        selectedOptions
                            ? selectedOptions.precision.match(/\d+-min/)
                                ? 60
                                : 3600
                            : 1
                    }
                    value={dateRange.max || ""}
                />
                <DateScroller doXScroll={doXScroll} />
            </div>
            <Button
                id="stackplots-refresh-button"
                onClick={beginLoad}
                disabled={loading}
            >
                {utilIcons.refresh(colors["ars-neutral-900"])}
            </Button>
        </div>
    );
}

function StackPlotTimeFrameSelector({ updateTimeframe }) {
    const [dateRange, setDateRange] = useState({ min: null, max: null });

    useEffect(() => {
        init();
    }, []);

    const init = () => {
        setDateRange({
            min: moment()
                .set("hour", 0)
                .set("minute", 0)
                .set("second", 0)
                .set("millisecond", 0)
                .set("date", 1)
                .subtract(1, "month")
                .format("YYYY-MM-DDTHH:mm"),
            max: moment()
                .set("hour", 0)
                .set("minute", 0)
                .set("second", 0)
                .set("millisecond", 0)
                .set("date", 1)
                .format("YYYY-MM-DDTHH:mm"),
        });
    };

    const fireUpdate = (event) => {
        const allowedIds = [
            "stackplot-timeframe-numdays-input",
            "stackplot-timeframe-mindate-input",
            "stackplot-timeframe-maxdate-input",
            "stackplot-timeframe-mode-select",
        ];
        if (
            event.relatedTarget?.id &&
            allowedIds.includes(event.relatedTarget.id)
        )
            return;
        if (dateRange.min && dateRange.max) {
            updateTimeframe(dateRange.min, dateRange.max);
        }
    };

    const handleMinDate = (event) => {
        const value = event.target.value;
        setDateRange((values) => ({ ...values, min: value }));
    };

    const handleMaxDate = (event) => {
        const value = event.target.value;
        setDateRange((values) => ({ ...values, max: value }));
    };

    return (
        <div id="stackplot-timeframe-selector">
            <input
                id="stackplot-timeframe-mindate-input"
                type="datetime-local"
                value={dateRange.min}
                onChange={handleMinDate}
                step={3600}
                onBlur={fireUpdate}
            />
            <span>to</span>
            <input
                id="stackplot-timeframe-maxdate-input"
                type="datetime-local"
                value={dateRange.max}
                onChange={handleMaxDate}
                onBlur={fireUpdate}
            />
        </div>
    );
}

function DateScroller({ doXScroll }) {
    const [quantity, setQuantity] = useState(1);
    const [unit, setUnit] = useState("days");

    const handleQuantity = (event) => {
        const value = Number(event.target.value);
        setQuantity(value);
    };

    const handleUnit = (event) => {
        const value = event.target.value;
        setUnit(value);
    };

    const handleMinus = () => {
        doXScroll({
            direction: "left",
            quantity,
            unit,
        });
    };

    const handlePlus = () => {
        doXScroll({
            direction: "right",
            quantity,
            unit,
        });
    };

    return (
        <div className="date-scroller">
            <Button onClick={handleMinus}>-</Button>
            <input
                className="time-quantity-input"
                type="number"
                step={1}
                value={quantity}
                onChange={handleQuantity}
            />
            <select
                className="time-unit-select"
                value={unit}
                onChange={handleUnit}
            >
                <option value="hours">Hour(s)</option>
                <option value="days">Day(s)</option>
                <option value="weeks">Week(s)</option>
                <option value="months">Month(s)</option>
            </select>
            <Button onClick={handlePlus}>+</Button>
        </div>
    );
}

function ParCodeSelector({ selectedSite }) {
    const [selectedParCodeList, setSelectedParCodeList] = useState([]);
    const [allParCodes, setAllParCodes] = useState(false);
    const [isOpen, setIsOpen] = useState(false);
    const [parCodeList, setParCodeList] = useState([]);

    const ref = useRef(null);

    const { sendGetRequest, sendPostRequest } = useContext(RestContext);

    const { dateRange, setSelectedPars } = useContext(DataValidationContext);

    const toggleOpen = () => setIsOpen(!isOpen);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (ref.current && isOpen) {
                if (
                    !ref.current.contains(event.target) &&
                    event.target.id !== "site-select"
                ) {
                    toggleOpen();
                }
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [ref, isOpen, toggleOpen]);

    useEffect(() => {
        if (allParCodes) {
            sendGetRequest(VALIDATION_URL + "/parameters/all", (response) => {
                setParCodeList(response.data);
            });
        } else {
            if (dateRange?.min && dateRange?.max) {
                const payload = {
                    siteId: selectedSite,
                    minDate: deTzTimestamp(dateRange.min),
                    maxDate: deTzTimestamp(dateRange.max),
                };
                console.log(payload);
                sendPostRequest(
                    VALIDATION_URL + "/parameters",
                    payload,
                    (response) => {
                        setParCodeList(response.data);
                    }
                );
            }
        }
    }, [selectedSite, allParCodes, dateRange]);

    useEffect(() => {
        const newSelected = [];
        for (let par of selectedParCodeList) {
            const foundPar = parCodeList.find(
                (other) => other.parCode === par.parCode
            );
            if (foundPar) newSelected.push(foundPar);
        }
        newSelected.sort(compPars);
        setSelectedParCodeList(newSelected);
    }, [parCodeList]);

    useEffect(() => {
        setSelectedPars(selectedParCodeList.map((par) => par.parCode));
    }, [selectedParCodeList]);

    const compPars = (a, b) => {
        return parCodeList.indexOf(a) - parCodeList.indexOf(b);
    };

    const togglePar = (par) => {
        const newSelected = [...selectedParCodeList];
        const foundPar = selectedParCodeList.find(
            (other) => other.parCode === par.parCode
        );
        if (foundPar) {
            newSelected.splice(newSelected.indexOf(foundPar), 1);
        } else {
            newSelected.push(par);
        }
        newSelected.sort(compPars);
        setSelectedParCodeList(newSelected);
    };

    const getSelectedList = () => {
        if (!selectedParCodeList.length) {
            return <span className="no-pars-selected">Select Parameters</span>;
        } else {
            return selectedParCodeList.map((par) => par.parCode).join(", ");

            // return `${selectedParCodeList.length} selected`;
        }
    };

    const isSelected = (par) => {
        return selectedParCodeList.some(
            (other) => other.parCode === par.parCode
        );
    };

    const reorder = (index, newIndex) => {
        if (
            index < 0 ||
            index >= parCodeList.length ||
            newIndex < 0 ||
            newIndex >= parCodeList.length
        )
            return;
        const newList = [...parCodeList];
        newList[index] = parCodeList[newIndex];
        newList[newIndex] = parCodeList[index];
        setParCodeList(newList);
    };

    const mapParCodesToList = () => {
        return parCodeList.map((par, index) => (
            <ParCodeListEntry
                par={par}
                parIndex={index}
                isSelected={isSelected(par)}
                togglePar={togglePar}
                reorder={reorder}
            />
        ));
    };

    return (
        <div
            id="validation-par-code-selector-wrapper"
            className="stackplot-control-wrapper"
            ref={ref}
        >
            <div id="validation-par-code-selector">
                <div id="par-code-selector-display" onClick={toggleOpen}>
                    {getSelectedList()}
                </div>
                <Collapse id="par-code-selector-collapse" isOpen={isOpen}>
                    <div id="par-code-selector-list-container">
                        {mapParCodesToList()}
                    </div>
                </Collapse>
            </div>
        </div>
    );
}

function ParCodeListEntry({ par, parIndex, isSelected, togglePar, reorder }) {
    const getAbbr = () => {
        if (!par?.parAbbr) return "";
        return par.parAbbr;
    };

    const handleClick = () => {
        togglePar(par);
    };

    return (
        <div className="validation-par-code-list-entry" onClick={handleClick}>
            <SortControls size="small" index={parIndex} updateFn={reorder} />
            <input type="checkbox" checked={isSelected} />
            <div className="validation-par-code-list-entry-abbr">
                {getAbbr()}
            </div>
        </div>
    );
}

function ValidationTable({ data }) {
    const { sendPostRequest } = useContext(RestContext);

    // useEffect(() => {
    //     const payload = {
    //         siteId: 1010,
    //         minDate: 1759276800000,
    //         maxDate: 1761955200000,
    //         parCodeList: ["O3-12"],
    //     };
    //     sendPostRequest(VALIDATION_URL + "/getData", payload, (response) => {
    //         setData(response.data);
    //     });
    // }, []);

    const getHeaders = () => {
        if (!data.length) return null;
        return (
            <tr>
                {Object.keys(AQMET_COLUMNS).map((column) => (
                    <th>{AQMET_COLUMNS[column]}</th>
                ))}
            </tr>
        );
    };

    const getRows = () => {
        if (!data.length) return null;
        const columns = Object.keys(AQMET_COLUMNS);
        return data.map((row) => (
            <tr>
                {columns.map((column) => (
                    <td>{formatColumn(column, row[column])}</td>
                ))}
            </tr>
        ));
    };

    const formatColumn = (column, value) => {
        const formatFn = {
            recordDate: formatTimestamp,
            updateDate: formatTimestamp,
            insertDate: formatTimestamp,
        };
        if (column in formatFn) {
            return formatFn[column](value);
        } else {
            return value;
        }
    };

    const formatTimestamp = (timestamp) => {
        return moment(timestamp).format("MM/DD/YYYY HH:mm");
    };

    return (
        <div id="validation-table-wrapper" className="half">
            <div id="validation-table">
                <table>
                    <thead>{getHeaders()}</thead>
                    <tbody>{getRows()}</tbody>
                </table>
            </div>
        </div>
    );
}

// function ValidationTable({ data, config, registerCallback }) {
// const [tableData, setTableData] = useState({});
//     const [size, setSize] = useState("minimized");
//     const [highlightedData, setHighlightedData] = useState({
//         chartIndex: null,
//         min: null,
//         max: null,
//     });

//     const tableRef = useRef(null);

//     useEffect(() => {
//         registerCallback("cursor", setHighlightedData);
//     }, []);

//     useEffect(() => {
//         if (data) {
//             setTableData(processData(data));
//         }
//     }, [data]);

//     useEffect(() => {
//         if (
//             highlightedData.min !== null &&
//             tableRef.current &&
//             size !== "minimized"
//         ) {
//             const highlightedRow = tableRef.current.querySelector(
//                 "#stackplot-table-row-" + highlightedData.min
//             );
//             if (highlightedRow) {
//                 highlightedRow.scrollIntoView({ block: "center" });
//             }
//         }
//     }, [size, highlightedData]);

//     const isCalPlot = () => {
//         return ["RAWCAL", "VALCAL"].includes(config?.dataType || "");
//     };

//     const processData = (data) => {
//         if (!config?.charts || !config?.calPars) return data;
//         let newTableData = { ...data };
//         if (Object.keys(data).some((key) => key.match(/DIFF/))) {
//             newTableData = generateDiffDatasets(data);
//         }
//         return newTableData;
//     };

//     const generateDiffDatasets = (data) => {
//         const newData = { ...data };
//         for (let chart of config.charts) {
//             let pDiffPar, diffPar;
//             const parameterList = chart.parameters;
//             if (
//                 (pDiffPar = parameterList.find(
//                     (parameter) => parameter.valType === "PDIFF"
//                 ))
//             ) {
//                 const isValidated = pDiffPar.parCode.match(/_VAL$/) !== null;
//                 const actualPar = parameterList.find((par) =>
//                     isValidated
//                         ? par.parCode.match(/_VAL$/) && par.valType === "ACTUAL"
//                         : !par.parCode.match(/_VAL$/) &&
//                           par.valType === "ACTUAL"
//                 );
//                 const indicatedPar = parameterList.find((par) =>
//                     isValidated
//                         ? par.parCode.match(/_VAL$/) &&
//                           par.valType === "INDICATED"
//                         : !par.parCode.match(/_VAL$/) &&
//                           par.valType === "INDICATED"
//                 );

//                 if (actualPar && indicatedPar) {
//                     const pDiffCalPar = [
//                         pDiffPar.parCode,
//                         pDiffPar.calType,
//                         pDiffPar.valType,
//                     ];
//                     const actualCalPar = [
//                         actualPar.parCode,
//                         actualPar.calType,
//                         actualPar.valType,
//                     ];
//                     const indicatedCalPar = [
//                         indicatedPar.parCode,
//                         indicatedPar.calType,
//                         indicatedPar.valType,
//                     ];
//                     const actualData = data[actualCalPar],
//                         indicatedData = data[indicatedCalPar];

//                     if (actualData && indicatedData) {
//                         newData[pDiffCalPar] = {};
//                         Object.keys(actualData)
//                             .sort()
//                             .filter((key) => key !== "columnIndex")
//                             .forEach((timestamp) => {
//                                 newData[pDiffCalPar][timestamp] =
//                                     isNumeric(
//                                         actualData[timestamp]
//                                             ? actualData[timestamp][0]
//                                             : null
//                                     ) &&
//                                     isNumeric(
//                                         indicatedData[timestamp]
//                                             ? indicatedData[timestamp][0]
//                                             : null
//                                     )
//                                         ? (
//                                               (100 *
//                                                   (indicatedData[timestamp][0] -
//                                                       actualData[
//                                                           timestamp
//                                                       ][0])) /
//                                               actualData[timestamp][0]
//                                           ).toFixed(2)
//                                         : null;
//                             });
//                     }
//                 }
//             } else if (
//                 (diffPar = parameterList.find(
//                     (parameter) => parameter.valType === "DIFF"
//                 ))
//             ) {
//                 const isValidated = diffPar.parCode.match(/_VAL$/) !== null;
//                 const actualPar = parameterList.find((par) =>
//                     isValidated
//                         ? par.parCode.match(/_VAL$/) && par.valType === "ACTUAL"
//                         : !par.parCode.match(/_VAL$/) &&
//                           par.valType === "ACTUAL"
//                 );
//                 const indicatedPar = parameterList.find((par) =>
//                     isValidated
//                         ? par.parCode.match(/_VAL$/) &&
//                           par.valType === "INDICATED"
//                         : !par.parCode.match(/_VAL$/) &&
//                           par.valType === "INDICATED"
//                 );

//                 if (actualPar && indicatedPar) {
//                     const diffCalPar = [
//                         diffPar.parCode,
//                         diffPar.calType,
//                         diffPar.valType,
//                     ];
//                     const actualCalPar = [
//                         actualPar.parCode,
//                         actualPar.calType,
//                         actualPar.valType,
//                     ];
//                     const indicatedCalPar = [
//                         indicatedPar.parCode,
//                         indicatedPar.calType,
//                         indicatedPar.valType,
//                     ];
//                     const actualData = data[actualCalPar],
//                         indicatedData = data[indicatedCalPar];

//                     if (actualData && indicatedData) {
//                         newData[diffCalPar] = {};
//                         Object.keys(actualData)
//                             .sort()
//                             .filter((key) => key !== "columnIndex")
//                             .forEach((timestamp) => {
//                                 newData[diffCalPar][timestamp] =
//                                     isNumeric(
//                                         actualData[timestamp]
//                                             ? actualData[timestamp][0]
//                                             : null
//                                     ) &&
//                                     isNumeric(
//                                         indicatedData[timestamp]
//                                             ? indicatedData[timestamp][0]
//                                             : null
//                                     )
//                                         ? (
//                                               indicatedData[timestamp][0] -
//                                               actualData[timestamp][0]
//                                           ).toFixed(actualPar.rawPrec)
//                                         : null;
//                             });
//                     }
//                 }
//             }
//         }

//         return newData;
//     };

//     const mapParameterListToHead = () => {
//         if (isCalPlot()) return mapCalParListToHead();
//         if (!config?.parCodes) return null;
//         // const parCodes = config.parCodes.filter(
//         //     (parCode) => parCode in tableData
//         // );
//         const parCodes = Object.keys(tableData).filter(
//             (parCode) => parCode !== "_timestamps"
//         );
//         return (
//             <tr>
//                 <th>Timestamp</th>
//                 {parCodes.map((parCode, index) => (
//                     <>
//                         <th key={`stackplot-table-head-${index}`}>{parCode}</th>
//                     </>
//                 ))}
//             </tr>
//         );
//     };

//     const mapCalParListToHead = () => {
//         if (!config.calPars) return null;
//         const parCodeHead = [<th>Par Code</th>];
//         const calTypeHead = [<th>Cal Type</th>];
//         const valTypeHead = [<th>Val Type</th>];
//         for (let calPar of config.calPars) {
//             parCodeHead.push(<th>{calPar[0]}</th>);
//             calTypeHead.push(<th>{calPar[1]}</th>);
//             valTypeHead.push(<th>{calPar[2]}</th>);
//             if (config.dataType === "VALCAL") {
//                 parCodeHead.push(<th>{calPar[0] + "_VAL"}</th>);
//                 calTypeHead.push(<th>{calPar[1]}</th>);
//                 valTypeHead.push(<th>{calPar[2]}</th>);
//             }
//         }
//         return (
//             <>
//                 <tr>{parCodeHead}</tr>
//                 <tr>{calTypeHead}</tr>
//                 <tr>{valTypeHead}</tr>
//             </>
//         );
//     };

//     const mapUnitListToHead = () => {
//         if (isCalPlot()) return mapCalUnitListToHead();
//         if (!config?.parCodes || !config?.unitCodes) return null;
//         const unitCodes = [<th />];
//         config.parCodes.forEach((parCode, index) => {
//             if (parCode in tableData) {
//                 unitCodes.push(config.unitCodes[index]);
//                 if (config.dataType === "VAL") {
//                     unitCodes.push(config.unitCodes[index]);
//                 }
//             }
//         });
//         return (
//             <tr>
//                 {unitCodes.map((unitCode, index) => (
//                     <th key={`stackplot-table-head-unit-${index}`}>
//                         {unitCode}
//                     </th>
//                 ))}
//             </tr>
//         );
//     };

//     const mapCalUnitListToHead = () => {
//         if (!config?.calPars || !config?.unitCodes) return null;
//         // const unitCodes = config.unitCodes.filter(
//         //     (unitCode, index) => config.calPars[index] in tableData
//         // );
//         const unitCodes = [];
//         config.calPars.forEach((calPar, index) => {
//             if (calPar in tableData) {
//                 unitCodes.push(config.unitCodes[index]);
//                 if (config.dataType === "VALCAL") {
//                     unitCodes.push(config.unitCodes[index]);
//                 }
//             }
//         });
//         return (
//             <tr>
//                 <th>Timestamp</th>
//                 {unitCodes.map((unitCode, index) => (
//                     <th key={`stackplot-table-head-unit-${index}`}>
//                         {unitCode}
//                     </th>
//                 ))}
//             </tr>
//         );
//     };

//     const isHighlighted = (rowIndex) => {
//         if (
//             !highlightedData ||
//             highlightedData.min === null ||
//             highlightedData.max === null
//         )
//             return false;
//         return (
//             rowIndex >= highlightedData.min && rowIndex <= highlightedData.max
//         );
//     };

//     const flagString = (par, timestamp, dataObj) => {
//         if (!dataObj) return "";
//         const flag = dataObj.at(1);
//         if (!flag) {
//             return "";
//         }
//         if (flag.match(/[A-Z]+\(.*\)/)) {
//             const code = flag.substring(0, flag.indexOf("("));
//             const adj = flag.substring(flag.indexOf("(") + 1, flag.length - 1);
//             const id = `${par.toString()}-${timestamp}-code`;
//             return (
//                 <>
//                     (
//                     <span
//                         id={id}
//                         style={{
//                             color: colors["ars-blue-400"],
//                             textDecoration: "underline",
//                         }}
//                     >
//                         {code}
//                     </span>
//                     )
//                     <UncontrolledTooltip placement="top" target={id}>
//                         {adj}
//                     </UncontrolledTooltip>
//                 </>
//             );
//         } else {
//             return dataObj.at(1) ? ` (${dataObj.at(1)})` : "";
//         }
//     };

//     const mapRows = () => {
//         if (isCalPlot()) return mapCalRows();
//         if (!tableData || !config?.parCodes || !config?.charts) return null;
//         // const parCodes = config.parCodes.filter(
//         //     (parCode) => parCode in tableData
//         // );
//         const parCodes = Object.keys(tableData).filter(
//             (parCode) => parCode !== "_timestamps"
//         );
//         const timestamps = tableData._timestamps;
//         if (!timestamps) return null;

//         const highlightedPars = [];
//         if (highlightedData.chartIndex !== null) {
//             const highlightedChart = config.charts[highlightedData.chartIndex];
//             if (highlightedChart) {
//                 for (let parameter of highlightedChart.parameters) {
//                     highlightedPars.push(parameter.parCode);
//                     if (config.dataType === "VAL") {
//                         highlightedPars.push(parameter.parCode + "_VAL");
//                     }
//                 }
//             }
//         }

//         const parCodePrec = {};
//         for (let chart of config.charts) {
//             for (let parameter of chart.parameters) {
//                 parCodePrec[parameter.parCode] = parameter.rawPrec;
//             }
//         }

//         return timestamps.map((timestamp, index) => {
//             const cells = [];
//             cells.push(
//                 <td>{moment.unix(timestamp).format("MMM D hh:mm a")}</td>
//             );
//             for (let parCode of parCodes) {
//                 cells.push(
//                     <>
//                         <td
//                             className={
//                                 highlightedPars.includes(parCode)
//                                     ? "highlighted"
//                                     : ""
//                             }
//                         >
//                             {tableData[parCode][timestamp]
//                                 ? tableData[parCode][timestamp].at(0) === null
//                                     ? "-"
//                                     : tableData[parCode][timestamp]
//                                           .at(0)
//                                           .toFixed(parCodePrec[parCode])
//                                 : "-"}
//                             {flagString(
//                                 parCode,
//                                 timestamp,
//                                 tableData[parCode][timestamp]
//                             )}
//                         </td>
//                     </>
//                 );
//             }
//             return (
//                 <tr
//                     key={`stackplot-table-row-${index}`}
//                     id={`stackplot-table-row-${index}`}
//                     className={
//                         "stackplot-table-row" +
//                         (isHighlighted(index) ? " highlighted-row" : "")
//                     }
//                 >
//                     {cells}
//                 </tr>
//             );
//         });
//     };

//     const mapCalRows = () => {
//         if (!tableData || !config?.calPars?.length || !config?.charts)
//             return null;
//         const calPars = Object.keys(tableData)
//             .filter((key) => key !== "_timestamps")
//             .map((calPar) => calPar.split(","));
//         if (!calPars.length) return null;
//         const firstCalPar = config.calPars[0];
//         if (!firstCalPar) return null;
//         const firstCalDataset = tableData[firstCalPar];
//         if (!firstCalDataset) return null;
//         const timestamps =
//             Object.keys(firstCalDataset)
//                 ?.filter((key) => key !== "columnIndex")
//                 ?.sort() || [];

//         const highlightedPars = [];
//         if (highlightedData.chartIndex !== null) {
//             const highlightedChart = config.charts[highlightedData.chartIndex];
//             if (highlightedChart) {
//                 for (let parameter of highlightedChart.parameters) {
//                     highlightedPars.push([
//                         parameter.parCode,
//                         parameter.calType,
//                         parameter.valType,
//                     ]);
//                 }
//             }
//         }

//         const calParPrec = {};
//         for (let chart of config.charts) {
//             for (let parameter of chart.parameters) {
//                 calParPrec[
//                     [parameter.parCode, parameter.calType, parameter.valType]
//                 ] = parameter.rawPrec;
//             }
//         }

//         const isHighlightedPar = (calPar) => {
//             return highlightedPars.some((highlightedPar) => {
//                 for (let i = 0; i < highlightedPar.length; i++) {
//                     if (highlightedPar[i] !== calPar[i]) return false;
//                 }
//                 return true;
//             });
//         };

//         return timestamps.map((timestamp, index) => {
//             const cells = [];
//             cells.push(
//                 <td>{moment.unix(timestamp).format("MMM D hh:mm a")}</td>
//             );
//             for (let calPar of calPars) {
//                 if (calPar[2].match(/P?DIFF/)) {
//                     cells.push(
//                         <>
//                             <td
//                                 className={
//                                     isHighlightedPar(calPar)
//                                         ? "highlighted"
//                                         : ""
//                                 }
//                             >
//                                 {tableData[calPar][timestamp] === null
//                                     ? "-"
//                                     : tableData[calPar][timestamp]}
//                             </td>
//                         </>
//                     );
//                 } else {
//                     cells.push(
//                         <>
//                             <td
//                                 className={
//                                     isHighlightedPar(calPar)
//                                         ? "highlighted"
//                                         : ""
//                                 }
//                             >
//                                 {tableData[calPar][timestamp]
//                                     ? tableData[calPar][timestamp]?.at(0) ===
//                                       null
//                                         ? "-"
//                                         : tableData[calPar][timestamp]
//                                               .at(0)
//                                               .toFixed(calParPrec[calPar])
//                                     : "-"}
//                                 {flagString(
//                                     calPar,
//                                     timestamp,
//                                     tableData[calPar][timestamp]
//                                 )}
//                             </td>
//                         </>
//                     );
//                 }
//             }
//             return (
//                 <tr
//                     key={`stackplot-table-row-${index}`}
//                     id={`stackplot-table-row-${index}`}
//                     className={
//                         "stackplot-table-row" +
//                         (isHighlighted(index) ? " highlighted-row" : "")
//                     }
//                 >
//                     {cells}
//                 </tr>
//             );
//         });
//     };

//     const convertToCsvString = () => {
//         if (isCalPlot()) return convertCalToCsvString();
//         if (!tableData || !config?.parCodes || !config?.charts) return null;
//         const parCodes = [],
//             unitCodes = [];
//         for (let index in config.parCodes) {
//             const parCode = config.parCodes[index];
//             if (parCode in tableData) {
//                 parCodes.push(parCode);
//                 unitCodes.push(config.unitCodes[index]);
//                 if (config.dataType === "VAL") {
//                     parCodes.push(parCode + "_VAL");
//                     unitCodes.push(config.unitCodes[index]);
//                 }
//             }
//         }

//         let csvString = "Date,Time";
//         for (let parCode of parCodes) {
//             csvString += `,${parCode},${parCode}_${
//                 parCode.match(/_VAL/) ? "CODE" : "FLAG"
//             }`;
//         }
//         csvString += "\n,";
//         for (let unitCode of unitCodes) {
//             csvString += `,${unitCode},`;
//         }
//         csvString += "\n";

//         const parCodePrec = {};
//         for (let chart of config.charts) {
//             for (let parameter of chart.parameters) {
//                 parCodePrec[parameter.parCode] = parameter.rawPrec;
//             }
//         }

//         const timestamps = tableData._timestamps;
//         for (let timestamp of timestamps) {
//             const cells = [];
//             cells.push(moment.unix(timestamp).format("YYYYMMDD,HHmm"));
//             for (let parCode of parCodes) {
//                 cells.push(
//                     tableData[parCode][timestamp]
//                         ?.at(0)
//                         ?.toFixed(parCodePrec[parCode])
//                 );
//                 cells.push(tableData[parCode][timestamp]?.at(1));
//             }
//             csvString += cells.join(",") + "\n";
//         }
//         return csvString;
//     };

//     const convertCalToCsvString = () => {
//         if (!tableData || !config?.calPars || !config?.charts) return null;
//         const calPars = [],
//             unitCodes = [];
//         for (let index in config.calPars) {
//             const calPar = config.calPars[index];
//             if (calPar in tableData) {
//                 calPars.push(calPar);
//                 unitCodes.push(config.unitCodes[index]);
//                 if (config.dataType === "VALCAL") {
//                     const valCalPar = [...calPar];
//                     valCalPar[0] = valCalPar[0] + "_VAL";
//                     calPars.push(valCalPar);
//                     unitCodes.push(config.unitCodes[index]);
//                 }
//             }
//         }
//         let csvString = ",Par Code";
//         for (let calPar of calPars) {
//             csvString += `,${calPar[0]},${calPar[0]}_${
//                 calPar[0].match(/_VAL/) ? "CODE" : "FLAG"
//             }`;
//         }
//         csvString += "\n,Cal Type";
//         for (let calPar of calPars) {
//             csvString += `,${calPar[1]},`;
//         }
//         csvString += "\n,Val Type";
//         for (let calPar of calPars) {
//             csvString += `,${calPar[2]},`;
//         }
//         csvString += "\nDate,Time";
//         for (let unitCode of unitCodes) {
//             csvString += `,${unitCode},`;
//         }
//         csvString += "\n";
//         const timestamps = [];
//         for (let calPar of calPars) {
//             for (let timestamp in tableData[calPar]) {
//                 if (timestamp === "columnIndex") continue;
//                 if (!timestamps.includes(timestamp)) {
//                     timestamps.push(timestamp);
//                 }
//             }
//         }
//         timestamps.sort();

//         const calParPrec = {};
//         for (let chart of config.charts) {
//             for (let parameter of chart.parameters) {
//                 calParPrec[
//                     [parameter.parCode, parameter.calType, parameter.valType]
//                 ] = parameter.rawPrec;
//             }
//         }

//         for (let timestamp of timestamps) {
//             const cells = [];
//             cells.push(moment.unix(timestamp).format("YYYYMMDD,HHmm"));
//             for (let calPar of calPars) {
//                 if (Array.isArray(tableData[calPar][timestamp])) {
//                     cells.push(
//                         tableData[calPar][timestamp]
//                             ?.at(0)
//                             ?.toFixed(calParPrec[calPar])
//                     );
//                     cells.push(tableData[calPar][timestamp]?.at(1));
//                 } else {
//                     cells.push(tableData[calPar][timestamp]);
//                     cells.push("");
//                 }
//             }
//             csvString += cells.join(",") + "\n";
//         }
//         return csvString;
//     };

//     return (
//         <div id="validation-table-wrapper" className={size}>
//             <div id="validation-table-controls">
//                 <span>Table View</span>
//                 <Button
//                     onClick={() => {
//                         setSize("minimized");
//                     }}
//                 >
//                     {utilIcons.minimized(colors["ars-neutral-900"])}
//                 </Button>
//                 <Button
//                     onClick={() => {
//                         setSize("half");
//                     }}
//                 >
//                     {utilIcons.halfScreen(colors["ars-neutral-900"])}
//                 </Button>
//                 <Button
//                     onClick={() => {
//                         setSize("full");
//                     }}
//                 >
//                     {utilIcons.fullScreen(colors["ars-neutral-900"])}
//                 </Button>
//             </div>
//             <div id="validation-table">
//                 <table ref={tableRef}>
//                     <thead>
//                         {mapParameterListToHead()}
//                         {mapUnitListToHead()}
//                     </thead>
//                     <tbody>{mapRows()}</tbody>
//                 </table>
//             </div>
//         </div>
//     );
// }

function LoadingScreen({ hidden, loadingProgress = 0, isMobile = false }) {
    const getContent = () => {
        if (isMobile) {
            return (
                <div className="loading-wrapper">
                    <progress value={loadingProgress} />
                    <span>{Math.round(loadingProgress * 1000) / 10}%</span>
                </div>
            );
        }
    };

    return (
        <div
            className={"loading" + (isMobile ? " mobile" : "")}
            hidden={hidden}
        >
            {getContent()}
        </div>
    );
}

export default DataValidation;
